import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, MasonryDiv } from './MasonryStyles';
import { createRandomId } from '../../../util/createRandomId';

const fillCols = (children, cols) => {
  children.forEach((child, i) => {
    child && cols.length && cols[i % cols.length].push(child);
  });
};

export default function Masonry({ children, gap, minWidth = 500, ...rest }) {
  const ref = useRef();
  const [numCols, setNumCols] = useState(4);
  const cols = [...Array(numCols)].map(() => []);

  fillCols(children, cols);

  return (
    <MasonryDiv className="masonry" ref={ref} gap={gap} {...rest}>
      {[...Array(numCols)].map((_, index) => (
        <Col key={createRandomId()} gap={gap}>
          {cols[index]}
        </Col>
      ))}
    </MasonryDiv>
  );
}

Masonry.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  gap: PropTypes.string.isRequired,
  minWidth: PropTypes.number.isRequired,
};
